import { render, staticRenderFns } from "./ExampleView.vue?vue&type=template&id=54c94cd8&"
import script from "./ExampleView.vue?vue&type=script&lang=js&"
export * from "./ExampleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports